module.exports = __webpack_public_path__ + "static/media/amex.2ce856a6.svg";